import moment from 'moment';

// Start/end are picked and displayed as SGT wall-clock time regardless of the
// browser timezone, but sent to the API as UTC.
const SGT_UTC_OFFSET_MINUTES = 8 * 60;

const SGT_WALL_CLOCK_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const HAS_UTC_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/;

// -> moment showing the value in SGT. Two kinds of input arrive here: an
// absolute instant ("...Z"), and legacy offset-less values that older records
// stored as SGT wall-clock time. The latter's digits must be kept rather than
// reinterpreted as browser-local time.
export const toSgtMoment = (value) => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string' && !HAS_UTC_OFFSET.test(value)) {
    return moment(value, SGT_WALL_CLOCK_FORMAT).utcOffset(
      SGT_UTC_OFFSET_MINUTES,
      true
    );
  }
  return moment(value).utcOffset(SGT_UTC_OFFSET_MINUTES);
};

// Picker moment -> UTC ISO string. The digits the user sees are read as SGT,
// so 10:00 in the UI leaves as 02:00Z. Going through the formatted digits
// matters for a fresh pick: antd builds that moment in the browser timezone,
// so its instant is wrong even though its digits are what the user chose.
export const toSgtPayload = (momentValue) => {
  if (!momentValue) {
    return null;
  }
  return moment(momentValue.format(SGT_WALL_CLOCK_FORMAT), SGT_WALL_CLOCK_FORMAT)
    .utcOffset(SGT_UTC_OFFSET_MINUTES, true)
    .toISOString();
};
